import script from "./PostDisbursementChangeRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDisbursementChangeRow.vue?vue&type=script&setup=true&lang=ts"

import "./PostDisbursementChangeRow.vue?vue&type=style&index=0&id=1d0fbe52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0fbe52"]])

export default __exports__